// Blog index: client-side topic filter + search over the rendered cards.
// No backend — the cards carry data-category and data-search; this just
// toggles `hidden`. Reflects the topic in ?topic= so footer links deep-link.
export function setupBlogFilters() {
  const grid = document.querySelector("[data-blog-grid]")
  if (!grid) return

  const cards = [...grid.querySelectorAll("[data-blog-post]")]
  const featured = document.querySelector("[data-blog-featured]")
  const empty = document.querySelector("[data-blog-empty]")
  const eyebrow = document.querySelector("[data-blog-eyebrow]")
  const heading = document.querySelector("[data-blog-heading]")
  const search = document.querySelector("[data-blog-search] input")
  const chips = [...document.querySelectorAll(".blog-chips [data-blog-filter]")]
  const labelFor = (slug) => chips.find((c) => c.dataset.blogFilter === slug)?.textContent.trim() || slug

  let topic = new URLSearchParams(location.search).get("topic") || ""
  let q = ""

  const apply = () => {
    const filtering = topic !== "" || q !== ""
    let shown = 0
    cards.forEach((card) => {
      const hitTopic = topic === "" || card.dataset.category === topic
      const hitQ = q === "" || card.dataset.search.includes(q)
      // The featured post has its own card up top when nothing is filtered.
      const dupFeatured = !filtering && card.dataset.featured === "true"
      const show = hitTopic && hitQ && !dupFeatured
      card.hidden = !show
      if (show) shown++
    })
    if (featured) featured.hidden = filtering
    // Unfiltered with a featured post and nothing else: the grid is
    // legitimately empty because that post is the one showing up top, not
    // because nothing matched — don't flash the "no results" empty state.
    if (empty) empty.hidden = shown > 0 || (!filtering && !!featured)
    chips.forEach((c) => c.classList.toggle("mca-filterbar__chip--active", c.dataset.blogFilter === topic))
    if (eyebrow) eyebrow.textContent = q ? "Search results" : topic ? "Topic" : "All posts"
    if (heading) heading.textContent = q ? `Posts matching “${search.value.trim()}”` : topic ? labelFor(topic) : "Latest answers"
    const url = new URL(location.href)
    topic ? url.searchParams.set("topic", topic) : url.searchParams.delete("topic")
    history.replaceState(null, "", url)
  }

  document.querySelectorAll("[data-blog-filter]").forEach((el) => {
    el.addEventListener("click", () => {
      topic = el.dataset.blogFilter
      if (topic === "" && el.closest("[data-blog-empty]")) { q = ""; if (search) search.value = "" }
      apply()
      if (el.classList.contains("topic-tile")) {
        const top = grid.getBoundingClientRect().top + window.scrollY - 120
        window.scrollTo({ top, behavior: "smooth" })
      }
    })
  })
  if (search) search.addEventListener("input", () => { q = search.value.trim().toLowerCase(); apply() })

  apply()
}
